<template>
  <div>
    <div class="form-container ou-donation-form alldaf-campign">
      <div class="holder">
        <PaymentForm class="form-horizontal">
        <div class="alldaf__header">
          <h2>פרנס השבוע Parnes HaShavua</h2>
          <div class="total__amt">$360</div>
        </div>
          <div class="steps-bar">
            <div
              v-for="(step, index) in steps"
              :key="index"
              :class="{
                'steps-bar__item--last': index >= steps - 1,
                'steps-bar__item--active': currentStep >= index + 1,
              }"
              class="steps-bar__item"
            >
              <div class="steps-bar__item-dot">
                {{ step === 1 ? 'Selection' : step === 2 ? 'Billing' : step === 3 ? 'Payment' : '' }}

              </div>
              <div class="steps-bar__item-line"></div>
            </div>
          </div>

          <div v-if="currentStep === 1" class="step">
            <FormSection title="">
              <div class="multiple__payoptions">
                    Select a week to sponsor
       
                    <Multiselect
                        class="multiselectall"
                        select-label=""
                        selected-label=""
                        deselect-label=""
                        v-model="selected"
                        :options="options"
                        :multiple="true"
                        track-by="parsha"
                        label="parsha"
                        :close-on-select="false"
                      ></Multiselect>

              </div>
              <br />
              <div>
                  <AlldafCalendar />
              </div>
  
            </FormSection>
            <!-- v-if="form.amount && Number(form.amount) > 0" -->
            <div class="step__btn-wrapper">
              <div class="btn btn--negative" @click="currentStep = 2">Continue</div>
            </div>
          </div>

          <div v-if="currentStep === 2" class="step">
            <FormSection title="2. Personal Information">
              <FormRow inline>
                <FormCol field="title" :flex="1" />
                <FormCol field="firstName" :flex="2" />
                <FormCol field="lastName" :flex="2" />
              </FormRow>
              <FormRow inline>
                <FormCol field="email" />
              </FormRow>
              <DonorAddress />
              <FormRow inline>
              <FormCol field="phone" />
            </FormRow>
              <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow> 
            </FormSection>
            <div class="step__btn-wrapper">
              <div class="btn btn--prev" @click="currentStep = 1">Previous</div>
              <div class="btn btn--negative" @click="currentStep = 3">Next</div>
            </div>
          </div>
          <div v-if="currentStep === 3" class="step">
            <FormSection title="3. Payment Information" last>
              <FormRow>
                <Receipt :receipts="['us', 'israel', 'canadian']" />
              </FormRow>            
              <FormCol field="card" :showLabel="false" />
            </FormSection>
            <FormSection last> </FormSection>

            <div class="step__btn-wrapper">
              <div class="btn btn--prev" @click="currentStep = 2">Previous</div>
              <PaymentButton showAmount btnText="Donate" />
            </div>
          </div>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { usePaymentForm } from "~/shared/use-payment-form";
import { defineComponent, ref, watch } from "vue";
import Multiselect from 'vue-multiselect';
import sum from "lodash/sum";

interface ValueObject {
  parsha: string;
}


export default defineComponent({
  components: { Multiselect },
  setup() {
    const { form, submit, setValue } = usePaymentForm();

    const state = ref(false);
    const selected = ref<ValueObject[]>([]);
    const options = ref<ValueObject[]>([
      { parsha: 'Bereishit' },
      { parsha: 'Noach' },
      { parsha: 'Lech Lecha' },
      { parsha: 'Vayeira' },
      { parsha: 'Toldos' },
      { parsha: 'Vayeitzei' },
    ]);


    return {
      form,
      steps: 3,
      currentStep: 1,
      finished: false,
      submit,
      selected,
      state,
      options
    };
  },
});
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

::v-deep .form-container.ou-donation-form {
  max-width: 900px;
}
::v-deep .ou-donation-form {
  line-height: 1.4;
  hr {
    // border-bottom: 2px dashed #ddd;
  }
  h2 {
    color: #15329d;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 15px;
  }

  input[type="email"],
  input[type="number"],
  input[type="password"],
  input[type="tel"],
  input[type="text"],
  textarea,
  select {
    font-size: 14px;
  }
  input[type="tel"] {
    height: 42px;
  }
}
::v-deep .frequency {
  display: flex;
  justify-content: space-between;

  .styled-radio-container--ou-donation.styled-radio-contain {
    margin: 0px 0px 0px auto;
    justify-content: flex-end;

    .radio-part {
      margin-bottom: 0px;
    }
    input[type="radio"] {
      position: relative;
    }
  }
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
input[type="checkbox"] {
  margin-right: 5px;
}
::v-deep .radio-part {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
  &:nth-child(3n) {
    padding-right: 0 !important;
  }
}
::v-deep .amount_other__wrapper {
  max-width: 29.666% !important;
}
::v-deep div[data-amount="12"] {
  order: 1;
  margin-left: 2%;
  padding-right: 0 !important;
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]
  + label[data-amount="12"] {
  padding: 8px 0 !important;
  display: block !important;
  &:after {
    content: "college student special";
    font-size: 11px;
    width: 100%;
    display: block;
    color: #666;
    margin-top: 3px;
  }
}

// ::v-deep .styled-radio--ou-donation.styled-radio input[type='radio']:not(:checked) + label[data-amount="100"] {
//   background: #eee7fd;
// }

::v-deep .styled-radio--ou-donation.styled-radio input[type="radio"]:not(:checked) + label {
  background: #e5e8e9;
  color: #222;
}
::v-deep .styled-radio--ou-donation.styled-radio input[type="radio"]:checked + label {
  background: #15329d;
  color: white;
}
::v-deep .styled-radio--ou-donation.styled-radio .amount_other__wrapper {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
}
::v-deep .ou-donation-form .ou-donation-btn {
  background: #15329d;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}
::v-deep .thank-you-container .ou-donation-btn {
  background: #15329d;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}

.donate__note {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid rgb(214, 233, 198);
  border-radius: 4px;
  color: rgb(60, 118, 61);
  background-color: rgb(223, 240, 216);
}

.membership {
  font-size: 14px;
  margin: 15px 0;
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #31708f;
  padding: 11px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
  p {
    margin: 0;
  }
  a {
    color: #2403ee;
    display: block;
    font-weight: bold;
  }
}

.charity__group {
  // height: 400px;
  margin: 15px 0;
  max-width: 700px;
  width: 100%;
  // border: 1px solid #ccc;
  // overflow: auto;
  padding: 10px 15px;
  background: white;
  gap: 20px;
  color: #667085;
}
.charity__wrapper {
  display: flex;
  @media (max-width: 720px) {
    flex-flow: column;
  }
}
.charity__left {
  flex: 1;
}
.charity__col {
  display: flex;
  // align-items: center;
  cursor: pointer;
  border-radius: 8px;
  position: relative;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
  &:hover {
    background-color: #fafafa;
  }

  @media (max-width: 720px) {
    flex-flow: column;
  }
}
.charity__img {
  flex: 0 1 100px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  background-size: cover;
  background-position: center;
  @media (min-width: 720px) {
    min-height: 75px;
  }
  img {
    height: 100px;
    width: auto;
    text-align: center;
    margin: 0 auto;
    @media (min-width: 720px) {
      object-position: center;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }
}

.charity__info {
  flex: 1;
  padding: 8px 10px;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: space-between;
  .charity__left {
  }
  .charity__right {
    margin-left: auto;
    align-self: flex-end;
  }

  .charity__icon {
    position: absolute;
    top: -5px;
    right: 0px;
    display: none;
    z-index: 999;
    background: white;
    .charity__icon--rm {
      svg {
        width: 25px;
        fill: black;
        padding: 5px;
        border-radius: 50%;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
          0 8px 10px -6px rgba(0, 0, 0, 0.1);
      }
    }
    .charity__icon--add {
      svg {
        width: 25px;
        fill: #e5e7eb;
        padding: 5px;
        border-radius: 50%;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
      }
    }
  }
}
.charity__title {
  color: black;
  font-weight: 600;
  padding-bottom: 5px;
  font-size: 15px;
  line-height: normal;
}
.charity__excerpt {
  overflow: hidden;
  color: #9ca3af;
  font-size: 13px;
  line-height: 1.3;
  max-width: calc(100% - 76px);
}

.charity__input {
  display: flex;
  justify-content: flex-end;
  input {
    height: 39px;
    max-width: 60px;
    border-color: #15329d;
    // border: 1px solid #d0d5dd;
    box-sizing: border-box;
    box-shadow: 0 1px 2px #1018280d;
    border-radius: 8px;
  }
}
.charity__action {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  margin-top: auto;
  font-weight: 600;
  color: white;

  span {
    background: #15329d;
    display: block;
    line-height: 1.4;
    font-size: 14px;
    padding: 5px 7px;
    position: relative;
    border-radius: 9999px;

    &.charity__action--rm {
      background: inherit;
      // color: #15329d;
      position: relative;
      margin-top: 5px;
      padding-right: 0px;
      color: #9ca3af;
      border-radius: 0px;
      text-transform: capitalize;
      text-decoration: underline;
    }
  }
}

.steps-bar {
  display: flex;
  max-width: 350px;
  margin: 35px auto 35px;
  justify-content: space-between;
}
.steps-bar__item {
  display: flex;
  position: relative;
  flex-grow: 1;
  &.steps-bar__item--last {
    flex-grow: 0;
  }
  &.steps-bar__item--active {
    .steps-bar__item-dot {
      background: #15329d;
      color: #ffffff;
      border: 1px solid #15329d;
    }
    .steps-bar__item-line {
      background: #15329d;
    }
  }
}

.steps-bar__item-dot {
  background: #ececec;
    border-radius: 25px;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 9px 6px;
    text-align: center;
    color: #15329d;
    border: 1px solid #cecece;
    line-height: 1.3;
}
.steps-bar__item-line {
  height: 2px;
  background: #e1e1e1;
  flex-grow: 1;
  top: 16px;
  position: relative;
}

.step__btn-wrapper {
  display: flex;
  // max-width: 330px;
  padding-top: 24px;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-between;
}

.step {
  max-width: 700px;
  margin: 0 auto;

  &.step--lg {
    max-width: 100%;
  }
}
.btn {
  padding: 13px 35px 11px 35px;
  border: 1px solid #15329d;
  color: #15329d;
  font-size: 16px;
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  text-decoration: none;
  line-height: 1;
  margin-bottom: 15px;
  padding-right: 25px;
  padding-left: 25px;
  margin-left: auto;

  &.btn--negative {
    background: #15329d;
    color: white;
  }
  &.btn.btn--disabled {
    opacity: 1;
    filter: grayscale(100%);
    background: #fafafa;
    color: #b9b9b9;
    border-color: #cfcfcf;
  }
  &.btn--prev {
    margin-left: 0px;
  }
}

.charity__cart {
  @media (min-width: 720px) {
    width: 40%;
    margin-left: 2%;
  }
  ul {
    padding: 0px;
    margin: 0px;
    position: relative;
    li {
      position: relative;

      .charity__list {
        width: 100%;
        justify-content: space-between;
        align-items: center;
        overflow: auto;
        padding: 10px;
        margin-bottom: 19px;
        gap: 5px;
        display: flex;
        border-radius: 0.5rem;
        border-width: 1px;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
      }
    }
  }
}
.charity__list__action {
  position: absolute;
  top: -15px;
  border-radius: 50%;
  // border: 1px solid gray;
  width: 18px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  right: -5px;
  padding: 5px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  &:hover {
    background-color: #fafafa;
    svg path {
      stroke: red;
    }
  }
}
.charity__list__title {
  color: #15329d;
  font-weight: bold;
  font-size: 14px;
  flex: 1;
}
.charity__list__amount {
  color: black;
  font-weight: 500;
  margin: 0 auto;
}
p.charity__total {
  color: #9ca3af;
  text-align: center;
  margin-bottom: 14px;
}

.total__summary {
  background: #fafafa;
  padding: 10px 15px;
  max-width: 300px;
  margin: 0 auto 24px;
}
.total__summary__total {
  color: black;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  font-size: 18px;
}
ul.total__summary__list {
  margin: 0px auto;
  display: flex;
  padding: 0px 0px 2px;
  justify-content: center;
  flex-flow: column;

  li {
    padding: 0px 0px;
  }
}
.tcharity__list {
  display: flex;
  font-weight: 500;
  line-height: 1.4;
  text-transform: capitalize;
  color: #232e38;
  gap: 10px;
  margin-bottom: 2px;
  padding-bottom: 5px;
  justify-content: space-between;
}
.tcharity__list__title {
  font-weight: 400;
  font-style: normal;
  font-size: 15px;
  color: #4b5866;
}
.tcharity__list__amount {
}
::v-deep .multiple__payoptions {
  .radio__label {
    flex-flow: wrap;
  }
  .monthly-note {
    width: 100%;
  }
}

::v-deep .multiselectall{
  .multiselect__tag {
    background: #1E50B4 !important;
    color: white;
  }
   .multiselect__tag-icon:after {
    color: #F7F7F7;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background:  #9ABBFF;
}
.multiselect__option.multiselect__option--highlight{
  background: #F7F7F7 !important;
}
.multiselect__option--selected.multiselect__option--highlight{
  background: #F7F7F7 !important;
}
.multiselect__option--selected:hover{
  background: #F7F7F7 !important;
}
}

.alldaf__header {
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
  align-items: center;
  padding-top: 10px;
  h2{
    margin: 0px;
  }
}
.total__amt {
  font-size: 20px;
  font-weight: bold;
  color: #15329d;
}
</style>
